import type { AssetLoader } from "@/components/assets/AssetLoader.js";
import type { AudioAsset } from "@/components/assets/AudioAsset.js";
import gameStartSoundWebm from "@rosette/assets/src/audio/game_start.webm";
import gameStartSoundMp3 from "@rosette/assets/src/audio/game_start.mp3";


export class GameMenuResources {
    private readonly gameStartSound: AudioAsset;

    constructor(assetLoader: AssetLoader) {
        this.gameStartSound = assetLoader.loadAudio(
            [gameStartSoundWebm, gameStartSoundMp3], { volume: 0.6 },
        );
    }

    getGameStartSound(): AudioAsset {
        return this.gameStartSound;
    }
}
